module.exports = __webpack_public_path__ + "static/media/zoomin.2c97c89a.svg";